import { GetTheme, Link, Section, ThemeProvider } from '@arp/react-ndbx';
import ArrowBackIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import { Typography } from '@mui/material';
import * as Sentry from '@sentry/react';
import React from 'react';
import '../../node_modules/@arp/react-ndbx/dist/index.css';
import { useEffect } from 'react';
import { URLS } from 'src/config/const/enums';
import { errorNotification } from 'src/config/disclaimers/disclaimers';

//* ----------------------------------------------------------------

export function Fallback() {
  const defaultTheme = GetTheme();
  useEffect(() => {
    Sentry.captureException(new Error());
  }, []);
  return (
    <ThemeProvider theme={defaultTheme}>
      <Section
        sx={{
          pl: { xs: 4, sm: 8 },
          pr: { xs: 4, sm: 8 },
          pt: { xs: 5 },
          mt: 0,
          mb: 0,
        }}
      >
        <Section sx={{ maxWidth: { xs: 448 }, mb: 4 }}>
          <Section sx={{ mt: 5, mb: { xs: 3, sm: 4 } }}>
            <Section sx={{ mb: 0 }}>
              <img
                alt="man_hitting_a_nail_with_hammer"
                width="100%"
                src="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/man_hitting_a_nail_with_hammer.svg"
              ></img>
            </Section>
          </Section>
        </Section>
      </Section>
      <Section sx={{ mt: 8, mx: 5 }}>
        <Typography variant="h3-bold">{errorNotification.IMPROVING_SERVICE}</Typography>
      </Section>
      <Section sx={{ mt: 5, mx: { xs: 5, sm: 8 } }}>
        <Typography variant="p3">{errorNotification.NOT_AVAILABLE_TRY_AGAIN}</Typography>
      </Section>
      <Section
        sx={{ mt: 6, mb: 8, px: 3 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <ArrowBackIcon
          sx={{
            fontSize: 16,
            color: defaultTheme.palette.action.PrimaryAction600,
          }}
        />
        <Link href={URLS.ALLIANZ_LIFE_HOMEPAGE}>{errorNotification.RETURN_ALLIANZ_HOMEPAGE}</Link>
      </Section>
    </ThemeProvider>
  );
}
